import React from "react"
import { Navigate, useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import VerticalLayout from "components/VerticalLayout"
import HorizontalLayout from "components/HorizontalLayout"

//constants
import { layoutTypes } from "../../constants/layout"

const Adminmiddleware = props => {
  const navigate = useNavigate()

  const layoutType = useSelector(state => state.Layout.layoutType)
  const token = useSelector(state => state.auth.token)
  const user = useSelector(state => state.auth.user)

  const getLayout = layoutType => {
    let Layout = VerticalLayout
    switch (layoutType) {
      case layoutTypes.VERTICAL:
        Layout = VerticalLayout
        break
      case layoutTypes.HORIZONTAL:
        Layout = HorizontalLayout
        break
      default:
        break
    }
    return Layout
  }

  const Layout = getLayout(layoutType)

  if (process.env.REACT_APP_IS_LIVE === "true") {
    if (token === null) {
      return (
        <Navigate
          to={{ pathname: "/login", state: { from: props.location } }}
        />
      )
    } else if (user.user_type === "user") {
      navigate("/unauthorized")
    }
  }

  return (
    <React.Fragment>
      <Layout>{props.children}</Layout>
    </React.Fragment>
  )
}

export default Adminmiddleware
